import { GUID } from '../Services/ServiceTypes'

const LAST_OPEN_FOLDER_NODES_KEY = 'lastOpenFolderNodes'

export const lastOpenFolderNodesStore = {
  get(): GUID[] {
    const data = localStorage.getItem(LAST_OPEN_FOLDER_NODES_KEY)
    if (!data) return []
    return JSON.parse(data) as GUID[]
  },
  set(lastOpenFolderNodeIds: GUID[]): void {
    localStorage.setItem(LAST_OPEN_FOLDER_NODES_KEY, JSON.stringify(lastOpenFolderNodeIds))
  },
  clear(): void {
    localStorage.removeItem(LAST_OPEN_FOLDER_NODES_KEY)
  },
}
